module.exports = __webpack_public_path__ + "static/media/t-image3.34e53924.jpg";